import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../../primitives/Rating/Bar/components/Container.js';
import { Description } from '../../../primitives/Rating/Bar/components/Description.js';
import { Score } from '../../../primitives/Rating/Bar/components/Score.js';
import { ScoreBar } from '../../../primitives/Rating/Bar/components/ScoreBar.js';
export const Bar = /*#__PURE__*/_styled(forwardRef(({
  sentiment,
  value,
  score,
  description,
  ...restProps
}, ref) => _jsxs(Container, {
  ...restProps,
  ref: ref,
  children: [_jsx(Score, {
    sentiment: sentiment,
    children: score
  }), _jsx(ScoreBar, {
    percentage: value,
    sentiment: sentiment
  }), description && _jsx(Description, {
    color: "contentTertiary",
    children: description
  })]
})), {
  label: 'RatingBar',
  target: "elzp5cx0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJhci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTRyIsImZpbGUiOiJCYXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwganN4cyBhcyBfanN4cyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvUmF0aW5nL0Jhci9jb21wb25lbnRzL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBEZXNjcmlwdGlvbiB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvUmF0aW5nL0Jhci9jb21wb25lbnRzL0Rlc2NyaXB0aW9uLmpzJztcbmltcG9ydCB7IFNjb3JlIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9SYXRpbmcvQmFyL2NvbXBvbmVudHMvU2NvcmUuanMnO1xuaW1wb3J0IHsgU2NvcmVCYXIgfSBmcm9tICcuLi8uLi8uLi9wcmltaXRpdmVzL1JhdGluZy9CYXIvY29tcG9uZW50cy9TY29yZUJhci5qcyc7XG5leHBvcnQgY29uc3QgQmFyID0gc3R5bGVkKGZvcndhcmRSZWYoKHsgc2VudGltZW50LCB2YWx1ZSwgc2NvcmUsIGRlc2NyaXB0aW9uLCAuLi5yZXN0UHJvcHMgfSwgcmVmKSA9PiAoX2pzeHMoQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgcmVmOiByZWYsIGNoaWxkcmVuOiBbX2pzeChTY29yZSwgeyBzZW50aW1lbnQ6IHNlbnRpbWVudCwgY2hpbGRyZW46IHNjb3JlIH0pLCBfanN4KFNjb3JlQmFyLCB7IHBlcmNlbnRhZ2U6IHZhbHVlLCBzZW50aW1lbnQ6IHNlbnRpbWVudCB9KSwgZGVzY3JpcHRpb24gJiYgKF9qc3goRGVzY3JpcHRpb24sIHsgY29sb3I6IFwiY29udGVudFRlcnRpYXJ5XCIsIGNoaWxkcmVuOiBkZXNjcmlwdGlvbiB9KSldIH0pKSksIHtcbiAgICBsYWJlbDogJ1JhdGluZ0JhcicsXG59KSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUJhci5qcy5tYXAiXX0= */");